<form [formGroup]="formData" (ngSubmit)="onSave(true)">
	<!-- TITLE & SAVE-CANCEL-EDIT BTN -->
	<div class="flex justify-between mb-[6px]">
		<p class="text-dark-grey font-DIN-Bold font-bold text-font-16">
			{{ 'PACKAGES.ADD_PACKAGE.PACKAGE_INFO' | translate }}
		</p>
		<div *ngIf="isEditMode">
			<button
				*ngIf="viewMode"
				(click)="viewMode = !viewMode"
				class="inline-block text-link text-font-14"
			>
				<img class="inline-block" src="./assets/images/edit-blue.svg" alt="" />

				{{ 'ACTIONS.EDIT' | translate }}
			</button>
		</div>
	</div>
	<!-- TITLE & SAVE-CANCEL-EDIT BTN -->
	<!-- FORM !VIEWMODE  -->
	<div
		*ngIf="!isEditMode || !viewMode"
		class="rounded-12px py-12px px-24px bg-off-white boxshadow"
	>
		<!-- PACKAGE NAME  -->
		<div formGroupName="name">
			<div>
				<mat-form-field class="w-full" appearance="outline">
					<mat-label class="text-dark-grey">
						{{ 'PACKAGES.ADD_PACKAGE.PACKAGE_NAME_EN' | translate }}
					</mat-label>
					<input formControlName="en" maxlength="35" matInput type="text" />
					<mat-error>
						<validation-message
							[controller]="getController('name').get('en')"
							controller_name="PACKAGES.ADD_PACKAGE.PACKAGE_NAME_EN"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
			</div>

			<div>
				<mat-form-field class="w-full" appearance="outline">
					<mat-label class="text-dark-grey">
						{{ 'PACKAGES.ADD_PACKAGE.PACKAGE_NAME_AR' | translate }}
					</mat-label>
					<input formControlName="ar" maxlength="35" matInput type="text" />
					<mat-error>
						<validation-message
							[controller]="getController('name').get('ar')"
							controller_name="PACKAGES.ADD_PACKAGE.PACKAGE_NAME_AR"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
			</div>
		</div>
		<!-- PACKAGE NAME  -->
		<!-- DESCRIPTION  -->
		<div formGroupName="description">
			<div>
				<mat-form-field class="w-full" appearance="outline">
					<mat-label>
						{{
							'PACKAGES.ADD_PACKAGE.PACKAGE_DESCRIPTION_EN' | translate
						}}</mat-label
					>
					<textarea formControlName="en" matInput></textarea>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field class="w-full" appearance="outline">
					<mat-label>{{
						'PACKAGES.ADD_PACKAGE.PACKAGE_DESCRIPTION_AR' | translate
					}}</mat-label>
					<textarea formControlName="ar" matInput></textarea>
				</mat-form-field>
			</div>
		</div>
		<!-- INSTRUCTIONS  -->
		<div formGroupName="instructions">
			<div>
				<mat-form-field class="w-full" appearance="outline">
					<mat-label class="text-dark-grey">
						{{ 'PACKAGES.ADD_PACKAGE.PACKAGE_INSTRUCTIONS_EN' | translate }}
					</mat-label>
					<input formControlName="en" matInput type="text" />
				</mat-form-field>
			</div>
			<div>
				<mat-form-field class="w-full" appearance="outline">
					<mat-label class="text-dark-grey">
						{{ 'PACKAGES.ADD_PACKAGE.PACKAGE_INSTRUCTIONS_AR' | translate }}
					</mat-label>
					<input formControlName="ar" matInput type="text" />
				</mat-form-field>
			</div>
		</div>
		<!-- INSTRUCTIONS  -->
		<!-- PRICE  -->
		<div>
			<mat-form-field class="w-full mb-[18px]" appearance="outline">
				<mat-label class="text-dark-grey">
					{{ 'PACKAGES.ADD_PACKAGE.PRICE' | translate }}
				</mat-label>
				<input
					(keypress)="skipLetterE($event); allowOnlyNumbers($event)"
					(keydown)="checkLength('price', $event, 3)"
					formControlName="price"
					matInput
					type="number"
					[min]="1"
				/>
				<mat-error>
					<validation-message
						[controller]="getController('price')"
						controller_name="price"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
		</div>
		<div *ngIf="!viewMode" class="flex items-center justify-end">
			<button
				(click)="viewMode = !viewMode"
				class="py-[10px] px-[24px] border-[1px] border-[#D9DBE9] rounded-6px text-dark-grey my-0 max-mobile:text-[8px] max-mobile:px-12px max-mobile:py-[6px] ltr:mr-12px rtl:ml-12px"
			>
				{{ 'ACTIONS.CANCEL' | translate }}
			</button>

			<button
				(click)="onSave(true); this.viewMode = !this.viewMode"
				class="bg-gradient text-off-white py-[10px] px-[24px] rounded-6px max-mobile:px-12px max-mobile:py-[6px] max-mobile:text-[8px] max-mobile:m-0 max-mobile:leading-[20px]"
			>
				{{ 'ACTIONS.SAVE' | translate }}
			</button>
		</div>
	</div>
	<!-- PRICE  -->

	<!-- FORM !VIEWMODE  -->
</form>
<!-- PACKAGE INFORMATION View mode  -->
<div
	class="rounded-12px py-12px px-24px bg-off-white boxshadow"
	*ngIf="isEditMode && viewMode"
>
	<div class="py-8px">
		<h1 class="text-dark-grey text-font-12 font-DIN-Bold font-bold m-0">
			Package Name English
		</h1>
		<p class="text-medium-gray text-font-16 mb-[8px]">
			{{ packageData?.name?.en }}
		</p>
	</div>
	<!-- DIVIDER  -->
	<div class="w-full h-[1px] bg-[#D9DBE9]"></div>
	<!-- DIVIDER  -->
	<div class="py-8px">
		<h1 class="text-dark-grey text-font-12 font-DIN-Bold font-bold m-0">
			Package Name Arabic
		</h1>
		<p class="text-medium-gray text-font-16 mb-[8px]">
			{{ packageData?.name?.ar }}
		</p>
	</div>
	<!-- DIVIDER  -->
	<div class="w-full h-[1px] bg-[#D9DBE9]"></div>
	<!-- DIVIDER  -->
	<div class="py-8px">
		<h1 class="text-dark-grey text-font-12 font-DIN-Bold font-bold m-0">
			Package description English
		</h1>
		<p class="text-medium-gray text-font-16 mb-[8px]">
			{{ packageData?.description?.en }}
		</p>
	</div>
	<!-- DIVIDER  -->
	<div class="w-full h-[1px] bg-[#D9DBE9]"></div>
	<!-- DIVIDER  -->
	<div class="py-8px">
		<h1 class="text-dark-grey text-font-12 font-DIN-Bold font-bold m-0">
			Package description Arabic
		</h1>
		<p class="text-medium-gray text-font-16 mb-[8px]">
			{{ packageData?.description?.ar }}
		</p>
	</div>
	<!-- DIVIDER  -->
	<div class="w-full h-[1px] bg-[#D9DBE9]"></div>
	<!-- DIVIDER  -->
	<div class="py-8px">
		<h1 class="text-dark-grey text-font-12 font-DIN-Bold font-bold m-0">
			Package Instructions English
		</h1>
		<p class="text-medium-gray text-font-16 mb-[8px]">
			{{ packageData?.instructions?.en }}
		</p>
	</div>
	<!-- DIVIDER  -->
	<div class="w-full h-[1px] bg-[#D9DBE9]"></div>
	<!-- DIVIDER  -->
	<div class="py-8px">
		<h1 class="text-dark-grey text-font-12 font-DIN-Bold font-bold m-0">
			Package Instructions Arabic
		</h1>
		<p class="text-medium-gray text-font-16 mb-[8px]">
			{{ packageData?.instructions?.ar }}
		</p>
	</div>
	<!-- DIVIDER  -->
	<div class="w-full h-[1px] bg-[#D9DBE9]"></div>
	<!-- DIVIDER  -->
	<div class="py-8px">
		<h1 class="text-dark-grey text-font-12 font-DIN-Bold font-bold m-0">
			package Price
		</h1>
		<p class="text-medium-gray text-font-16 mb-[8px]">
			{{ packageData?.price }}
		</p>
	</div>
</div>
<!-- PACKAGE INFORMATION  -->
